module.exports = __webpack_public_path__ + "static/media/hermes.2397104a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/hermes.jpg
// module id = 1445
// module chunks = 0